/**
 * @generated SignedSource<<bd35679a6bd656c32041aa0ddee8d13e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScopePicker_scopes$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccountGroupPicker_accountGroups" | "PolicyCollectionPicker_policyCollections" | "RepositoryPicker_repositoryConfigs">;
  readonly " $fragmentType": "ScopePicker_scopes";
};
export type ScopePicker_scopes$key = {
  readonly " $data"?: ScopePicker_scopes$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScopePicker_scopes">;
};

import ScopePickerRefetchQuery_graphql from './ScopePickerRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "accountGroupFilterElement"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "policyCollectionFilterElement"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": ScopePickerRefetchQuery_graphql
    }
  },
  "name": "ScopePicker_scopes",
  "selections": [
    {
      "args": (v0/*:: as any*/),
      "kind": "FragmentSpread",
      "name": "AccountGroupPicker_accountGroups"
    },
    {
      "args": (v0/*:: as any*/),
      "kind": "FragmentSpread",
      "name": "PolicyCollectionPicker_policyCollections"
    },
    {
      "args": (v0/*:: as any*/),
      "kind": "FragmentSpread",
      "name": "RepositoryPicker_repositoryConfigs"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "69c90ae83526ac07efa5fe5b1b31a2e7";

export default node;
